module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AloneAgreementsView.js"));
	}, "AloneAgreementsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AloneAgreementsView!./src/pages/Shop/Member/Agreements/aloneAgreements/AloneAgreementsView.js
// module id = 963
// module chunks = 431